import React, { RefObject } from 'react';
import { Button, Grid, Header, Icon, Menu, Sidebar } from "semantic-ui-react";
import { strings } from '../..';
import { DestinatarioMatricola, DestinatarioMatricoleMobile, FiltroMatricole, Matricola, TipoIntervento } from '../../core-assistenza';

type SelezionaMatricolaMobileProps = {
    tipologia: TipoIntervento,
    destinatariMatricole: ReadonlyArray<DestinatarioMatricola>,
    onSelectMatricola: (matricola: Matricola) => void,
    loadMatricole: (tipologia: TipoIntervento, search?: string) => void
}

type SelezionaMatricolaMobileState = {
    sidebarVisible: boolean,
    active: string,
    selezionato: string
}

export default class SelezionaMatricolaMobile extends React.Component<SelezionaMatricolaMobileProps, SelezionaMatricolaMobileState> {
    constructor(props: SelezionaMatricolaMobileProps) {
        super(props);

        this.state = { 
            sidebarVisible: false, 
            active: '',
            selezionato: '' 
        };
    }

    render() {
        const { onSelectMatricola } = this.props;
        const destinatariMatricole = this.props.destinatariMatricole || [];
        
        const refs = destinatariMatricole.reduce((acc: Map<string, RefObject<HTMLDivElement>>, value: DestinatarioMatricola) => {
            acc.set(value.idDestinatario, React.createRef<HTMLDivElement>());
            return acc;
        }, new Map<string, RefObject<HTMLDivElement>>());
        const handleClick = (id: string) => {
            refs.get(id)!.current!.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });

            this.setState({ selezionato: id, sidebarVisible: false });
        };

        return (
            <Grid>
            <Sidebar.Pushable>
                <Sidebar as={Menu} inverted vertical animation='push' direction='left' visible={this.state.sidebarVisible}>
                    <Menu.Item>
                        <Icon name='close' onClick={this.onToggle} /><br />
                    </Menu.Item>
                    <Menu.Item>
                        <Menu.Header>{strings.chiamate.selezionaMatricola.selezionaSede}</Menu.Header>
                    </Menu.Item>
                    {destinatariMatricole.map(destinatario => (
                        <Menu.Item
                            key={destinatario.idDestinatario}
                            onClick={() => handleClick(destinatario.idDestinatario)}
                            active={this.state.active === destinatario.idDestinatario}>
                            {destinatario.destinatario}
                        </Menu.Item>
                    ))}
                </Sidebar>
                <Sidebar.Pusher as={Grid} centered dimmed={this.state.sidebarVisible} onClick={this.onPusherClick}>
                    <Grid.Row>
                        <Grid.Column width='5'>
                            <Button primary icon='home' content='Sedi' onClick={this.onToggle} />
                        </Grid.Column>
                        <Grid.Column width='10'>
                            <FiltroMatricole onSearch={(search: string) => this.props.loadMatricole(this.props.tipologia, search)} />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width='15'>
                            <Header as='h3' attached='top'>
                                <Icon name='print' />
                                {strings.chiamate.selezionaMatricola.selezionaMatricola}
                            </Header>
                            {destinatariMatricole.map(destinatario => (
                                <div key={destinatario.idDestinatario} ref={refs.get(destinatario.idDestinatario)}>
                                    <DestinatarioMatricoleMobile
                                        key={destinatario.idDestinatario}
                                        elemento={destinatario}
                                        onSelectMatricola={onSelectMatricola}
                                        active={this.state.selezionato}
                                    />
                                </div>
                            ))}
                        </Grid.Column>
                    </Grid.Row>
                </Sidebar.Pusher>
            </Sidebar.Pushable>
            </Grid>
        );
    }    
    
    onPusherClick = () => {
        const { sidebarVisible } = this.state;
    
        if (sidebarVisible) this.setState({ sidebarVisible: false });
    }

    onToggle = () => this.setState({ sidebarVisible: !this.state.sidebarVisible });
}